module.exports = __webpack_public_path__ + "img/dev-board.1b10fa16.gif";